<template>
  <div>
    <vs-popup :title="$t('UploadAttachments')" :active.sync="showModal">
      <div class="pb-10 flex flex-col gap-6" v-if="show">
        <div class="flex flex-col gap-1">
          <label class="text-sm">{{ $t("AttachmentType") }}</label>
          <v-select
            :options="attachmentTypes"
            v-model="AttachmentType"
            :reduce="(x) => x.id"
            @option:selected="resetForm"
          ></v-select>
          <div class="h-6">
            <span
              class="text-danger text-sm mr-1"
              v-if="!AttachmentType && showError"
              >لطفا نوع پیوست را انتخاب کنید</span
            >
          </div>
        </div>
        <div class="flex justify-center w-full" @click="validateAttachmentId">
          <div
            :class="[
              AttachmentType
                ? ''
                : 'opacity-75 cursor-not-allowed pointer-events-none',
            ]"
          >
            <vue-upload-multiple-image
              :key="AttachmentType + uploaderKey"
              @upload-success="uploadSuccess"
              @before-remove="resetForm"
              :data-images="uploadedImages"
              :maxImage="1"
              :multiple="false"
              :dragText="$t('DragAndDrop')"
              :browseText="$t('UploadFile')"
              :showEdit="false"
              :showDelete="true"
              :showPrimary="false"
            ></vue-upload-multiple-image>
          </div>
        </div>
        <div class="w-full flex justify-end">
          <vs-button
            @click="validateAttachmentId"
            :disabled="!payload.file"
            @click.prevent="uploadImage"
            >{{ $t("Upload") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss"></style>

<script>
import { mapActions } from "vuex";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import vSelect from "@/components/CustomVSelect.vue";

export default {
  props: {
    show: { default: false },
    attachmentTypes: { rquired: true },
    contentItemId: { required: true },
  },
  data() {
    return {
      uploadedImages: [],
      uploaderKey: 1,
      AttachmentType: null,
      payload: {},
      showError: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      postImage: "contentType/postContentItemAttachment",
    }),
    resetForm() {
      this.payload = {};
      this.uploadedImages = [];
      this.uploaderKey++;
    },
    uploadImage() {
      this.postImage(this.payload).then((response) => {
        if (response) {
          this.$emit("success");
          this.$emit("close");
          this.$swal({
            position: "center-center",
            type: "success",
            text: "فایل با موفقیت آپلود شد",
            showConfirmButton: false,
            timer: 2000,
          });
          this.AttachmentType = null;
          this.payload = {};
          this.showError = false;
        }
      });
    },
    uploadSuccess(formData, index, fileList) {
      this.payload = {
        contentId: Number(this.$route.params.id),
        contentItemId: this.contentItemId,
        type: this.AttachmentType,
        alt: fileList[index].name,
        file: fileList[index].path,
      };
    },
    validateAttachmentId() {
      if (!this.AttachmentType) {
        this.showError = true;
      }
    },
  },
  watch: {
    show() {
      this.$validator.reset();
    },
  },
  components: {
    "v-select": vSelect,
    VueUploadMultipleImage,
  },
};
</script>
